import { Component, Input, OnInit } from '@angular/core';

import { Goal } from '../../../../../canvas/components/sustainability-goals/goals/goal';
import { GoalsService } from '../../../../../canvas/components/sustainability-goals/goals/goals.service';

@Component({
  selector: 'app-impact-society',
  templateUrl: './impact-society.component.html',
  styleUrls: ['./impact-society.component.css']
})
export class ImpactSocietyComponent implements OnInit {

  @Input() onShowPeriod;
  windowWith;
  mockGoals: Goal [];
  goals: Goal [];
  
  constructor(
    private _goalsService: GoalsService
  ) {}

  getMockGoals(): void {
    this._goalsService.getMockGoals().then(mockGoals => this.mockGoals = mockGoals);
  }

  getGoals(): void {
    this._goalsService.getGoals().then(goals => this.goals = goals);
  }

  ngOnInit(): void {
    this.windowWith = window.innerWidth;
    this.getMockGoals();
    this.getGoals();
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
  }

  breakRow(theArr: any[]) {
    const arrOfarr = [];
    if (this.windowWith > 768) {
      for (let i = 0; i < theArr.length ; i+=3) {
        const row = [];
        for (let x = 0; x < 3; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else if (this.windowWith > 480) {
      for (let i = 0; i < theArr.length ; i+=2) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 2; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else {
      for (let i = 0; i < theArr.length ; i+=1) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 1; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/today/components/impact-society/impact-society.component.ts